if (!customElements.get('ls-go-package-preview')) {
  customElements.define('ls-go-package-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.submitting ??= false;
      const options = { signal: this.controller.signal };
      this.radios = [...this.querySelectorAll('input[type="radio"]')];
      this.input = this.querySelector('input[type="number"]');
      this.minus = this.querySelector('[data-step="-1"]');
      this.plus = this.querySelector('[data-step="1"]');
      this.tiers = this.radios.map(r => ({ quantity: Number(r.value), cents: Number(r.dataset.unitPrice), radio: r })).sort((a,b) => a.quantity-b.quantity);
      this.purchaseForm = this.querySelector('.ls-go-packs__purchase-form');
      const rawMax = Number(this.dataset.maxQuantity);
      this.max = Number.isSafeInteger(rawMax) && rawMax >= 0 ? rawMax : 0;
      this.valid = this.tiers.length === 3 && this.tiers.every((t,i) => t.quantity === [1,2,3][i] && t.cents === [159900,149900,139900][i] && (i===0 || t.cents<=this.tiers[i-1].cents));
      this.format = new Intl.NumberFormat(document.documentElement.lang || 'sv-SE', { maximumFractionDigits: 2 });
      window.addEventListener('pageshow', () => {
        this.submitting = false;
        this.syncPurchaseControls();
      }, options);
      this.addEventListener('submit', event => {
        this.update(this.input.value);
        if (event.target !== this.purchaseForm || !this.purchaseAllowed() || this.submitting) {
          event.preventDefault();
          return;
        }
        this.submitting = true;
      }, options);
      this.addEventListener('change', event => {
        if (this.radios.includes(event.target)) this.update(event.target.value);
        else if (event.target === this.input) this.update(this.input.value);
      }, options);
      this.addEventListener('input', event => {
        if (event.target === this.input && this.input.value !== '') this.update(this.input.value);
      }, options);
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-step]');
        if (button && !button.disabled) this.update(this.quantity + Number(button.dataset.step));
      }, options);
      this.update(this.input.value || 1);
    }
    purchaseAllowed() {
      return this.dataset.purchaseEnabled === 'true' && this.valid && this.max > 0 && !this.input.disabled;
    }
    syncPurchaseControls() {
      const disabled = !this.purchaseAllowed();
      this.purchaseForm?.querySelectorAll('fieldset, input[name="id"], input[name="quantity"], button[type="submit"]').forEach(control => {
        control.disabled = disabled;
      });
    }
    update(value) {
      if (!this.valid) { this.syncPurchaseControls(); return; }
      const number = Number(value);
      this.quantity = Math.max(1,Math.min(Math.max(1,this.max),Number.isFinite(number)?Math.trunc(number):1));
      const tier = this.tiers.filter(t=>t.quantity<=this.quantity).at(-1);
      const unavailable=this.max<1 || this.input.disabled;
      this.input.value=String(this.quantity);
      this.minus.disabled=unavailable || this.quantity<=1;
      this.plus.disabled=unavailable || this.quantity>=this.max;
      this.tiers.forEach(t => { t.radio.checked=!unavailable && !t.radio.disabled && t===tier; });
      this.querySelector('[data-summary-quantity]').textContent=this.dataset.summaryTemplate.replace('__COUNT__',String(this.quantity)).replace('__PRICE__',this.format.format(tier.cents/100)).replace(/^1 förpackningar/, '1 förpackning');
      this.querySelector('[data-summary-total]').textContent=this.format.format(this.quantity*tier.cents/100)+' '+this.dataset.currency;
      this.querySelector('[data-form-quantity]').value=String(this.quantity);
      this.dataset.selectedQuantity=String(this.quantity);
      this.dataset.selectedUnitPrice=String(tier.cents);
      this.dataset.selectedTotal=String(this.quantity*tier.cents);
      this.syncPurchaseControls();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller=null; }
  });
}
